import { useState, useEffect, useCallback } from 'react';
import { carregarRelatorioPortal } from '../../lib/portal';
import RelatorioView from './RelatorioView';

function hoje() { return new Date().toISOString().split('T')[0]; }
function diasAtras(n) { return new Date(Date.now() - n * 86400000).toISOString().split('T')[0]; }
function inicioDoMes(offsetMeses = 0) {
  const d = new Date();
  d.setDate(1); d.setMonth(d.getMonth() + offsetMeses);
  return d.toISOString().split('T')[0];
}
function fimDoMes(offsetMeses = 0) {
  const d = new Date();
  d.setMonth(d.getMonth() + offsetMeses + 1, 0);
  return d.toISOString().split('T')[0];
}

const PRESETS = [
  { key: '15d', label: 'Últimos 15 dias', inicio: () => diasAtras(15), fim: hoje },
  { key: '30d', label: 'Últimos 30 dias', inicio: () => diasAtras(30), fim: hoje },
  { key: 'mes', label: 'Este mês', inicio: () => inicioDoMes(0), fim: () => fimDoMes(0) },
  { key: 'mes-passado', label: 'Mês passado', inicio: () => inicioDoMes(-1), fim: () => fimDoMes(-1) },
];

export default function PortalRelatorios({ token }) {
  const [presetAtivo, setPresetAtivo] = useState('15d');
  const [inicio, setInicio] = useState(diasAtras(15));
  const [fim, setFim] = useState(hoje());
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');

  const carregar = useCallback(() => {
    setCarregando(true); setErro('');
    carregarRelatorioPortal(token, inicio, fim)
      .then(setDados)
      .catch(e => setErro(e.message))
      .finally(() => setCarregando(false));
  }, [token, inicio, fim]);

  useEffect(() => { carregar(); }, [carregar]);

  function aplicarPreset(p) {
    setPresetAtivo(p.key);
    setInicio(p.inicio());
    setFim(p.fim());
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>
        {PRESETS.map(p => (
          <button key={p.key} onClick={() => aplicarPreset(p)} className={`tab-btn${presetAtivo === p.key ? ' active' : ''}`}>{p.label}</button>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 20, flexWrap: 'wrap' }}>
        <input type="date" value={inicio} onChange={e => { setPresetAtivo(''); setInicio(e.target.value); }}
          style={{ padding: '7px 10px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 12.5, background: 'var(--bg-secondary)' }} />
        <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>até</span>
        <input type="date" value={fim} onChange={e => { setPresetAtivo(''); setFim(e.target.value); }}
          style={{ padding: '7px 10px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 12.5, background: 'var(--bg-secondary)' }} />
      </div>

      {carregando && <div className="portal-estado">Carregando...</div>}
      {erro && <div className="portal-estado">{erro}</div>}
      {!carregando && !erro && dados && <RelatorioView dados={dados} />}
    </div>
  );
}
